import { withStyles } from '@material-ui/core/styles';
import { Slider } from '@material-ui/core';
import colors from '../../../theme/colors';

const StyledSlider = withStyles({
  markLabel: {
    marginTop: 12,
    color: colors.madison,
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '18px',
  },
  root: {
    color: colors.bright_turquoise,
    height: 2,
    marginRight: 19,
    marginLeft: 7,
    width: 'calc(100% - 19px)',
  },
  thumb: {
    height: 25,
    width: 25,
    backgroundColor: colors.bright_turquoise,
    boxShadow: 'none',
    marginTop: -12,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: colors.gallery,
      width: 25,
      height: 25,
      marginTop: -12,
      marginLeft: -12,
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 11px)',
    top: -22,
    '& *': {
      background: 'transparent',
      color: colors.madison,
    },
  },
  track: {
    height: 4,
    '&.Mui-disabled': {
      backgroundColor: colors.gallery,
    },
  },
  rail: {
    height: 4,
    opacity: 0.5,
    backgroundColor: colors.gallery,
  },
  mark: {
    borderRadius: '50%',
    height: 12,
    width: 12,
    marginTop: -6,
    marginLeft: -6,
    backgroundColor: colors.white,
    border: `2px solid ${colors.silver}`,
    '&.MuiSlider-markActive': {
      backgroundColor: colors.bright_turquoise,
      border: '2px solid',
    },
    '&:focus, &:hover': {
      boxShadow: 'none',
      border: `2px solid ${colors.bright_turquoise}`,
      backgroundColor: colors.bright_turquoise,
    },
  },
  markActive: {
    opacity: 1,
  },
})(Slider);

export default StyledSlider;
